import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Accordion, AccordionTab } from "primereact/accordion";

export interface IDateSetting {
    id?: number;
    dateFormat: string;
}

interface IProps {
    setModal: (modal: { open: boolean; singleData: IDateSetting }) => void;
    reload: boolean;
    toast: any;
}

const EmptyDateSetting: IDateSetting = {
    dateFormat: "",
};

export const Table = ({ reload, setModal }: IProps) => {
    const [data, setData] = useState<IDateSetting[]>([]);
    const [activeIndex, setActiveIndex] = useState<number | number[]>();

    const openNew = () => {
        setModal({ open: true, singleData: EmptyDateSetting });
    };

    const leftToolbarTemplate = () => (
        <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
    );

    const loadTableData = async () => {
        const response = await Fetch("Website_Settings/getDateSetting", "GET", null, null, null);
        if (response) {
            const result = await response.json();
            setData(result ? [result] : []);
        }
    };


    useEffect(() => {
        loadTableData();
    }, [reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} />
            <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} >
                <AccordionTab header="No. of Date Formate">
                    <DataTable value={data} size="small" emptyMessage="No Data found." className="p-datatable-sm"
                        paginator
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rows={5}
                        rowsPerPageOptions={[5, 10, 20]}
                    >

                        <Column field="dateFormat" header="Date Format" />
                        <Column header="Action"
                            body={(rowData: IDateSetting) => (
                                <i className="pi pi-pencil text-primary" style={{ cursor: "pointer" }} onClick={() => setModal({ open: true, singleData: rowData })} />
                            )}
                        />
                    </DataTable>
                </AccordionTab>
            </Accordion>
        </>
    );
};
